import { format, isValid } from "date-fns";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { SHORT_DATE_FORMAT } from "web_myplann/Shared/Utils/dateFormatters";

export const capitalizeFirstLetter = (str: string | null | undefined) => {
	if (!str) return "";

	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const nameFormatter = (
	fullName: string,
	bornDate?: string | null,
	identificationNumber?: string | null,
): string => {
	let output = fullName;

	const parsedDate = bornDate ? new Date(bornDate) : null;
	const bornDateValid = parsedDate && isValid(parsedDate);

	if (bornDateValid) {
		output += ` (${format(parsedDate, SHORT_DATE_FORMAT)})`;
	} else if (identificationNumber) {
		output += ` (${identificationNumber})`;
	}

	return output;
};

export const formatNumberOfDocuments = (
	count: number,
	t: (key: string) => string,
) => {
	if (count === 0) return t(Resources.Common.NoDocuments);
	if (count === 1) return `${count} ${t(Resources.Common.OneDocument)}`;
	if (count > 1 && count < 5)
		return `${count} ${t(Resources.Common.FewDocuments)}`;

	return `${count} ${t(Resources.Common.MoreDocuments)}`;
};

export const joinTruthy = (
	parts: ReadonlyArray<string | false | null | undefined>,
	separator = " - ",
) => parts.filter((part): part is string => Boolean(part)).join(separator);
